const CHANGE_USER_SETTINGS_DOUBLE_CLICK = "CHANGE_USER_SETTINGS_DOUBLE_CLICK";
const CHANGE_USER_SETTINGS_LANGUAGE = "CHANGE_USER_SETTINGS_LANGUAGE";
const CHANGE_USER_SETTINGS_CALENDAR = "CHANGE_USER_SETTINGS_CALENDAR";

const handleChangeDoubleClickAction = (doubleClickAction) => ({
    type: CHANGE_USER_SETTINGS_DOUBLE_CLICK,
    payload: {
        doubleClickAction
    }
})

export {
    handleChangeDoubleClickAction, 
    CHANGE_USER_SETTINGS_DOUBLE_CLICK,
    CHANGE_USER_SETTINGS_LANGUAGE,
    CHANGE_USER_SETTINGS_CALENDAR,
};
